module.exports = __webpack_public_path__ + "fonts/iconfont.47fad60.woff";